// First-party
import { createPage } from '@/common/util/templateHelpers';

// Component lib
import { Meta } from '@/common/components/head';

// Local
import { Block, Content, RouterLink, Title } from '@/common/components';
import AboutPageLayout from '@/layouts/AboutPageLayout';
import { generateContactLDJSON, generateWebsiteLDJSON } from '@/common/components/head/Meta';

export default createPage('ContactUsPage', { }, function ContactUsPage ({ className }, _props) {

  return (
    <AboutPageLayout className={className}>
      <Meta 
        titleTag='Contact Us | Addicting Games'
        title='Contact Us' 
        name='Contact Addicting Games'
        openGraph={
          {
            updated_time: '2019-06-11T10:37:42-07:00',
            'article:published_time': '2018-08-02T07:22:08-07:00',
            'article:modified_time': '2019-06-11T10:37:42-07:00',
            url: process.env.APP_CONFIG.URL + '/about/contact-us'
          }
        }
        ldjson={[ ...generateWebsiteLDJSON('/'), ...generateContactLDJSON('/about/contact-us') ]}
      />

      <Block>
        <Title>Contact Us</Title>

        <Content>
          <p>Have some feedback for the site? Need help with something? Got a game you want to pitch? <RouterLink href='https://addictinggameshelp.zendesk.com/hc/en-us/requests/new' target='_blank'>Click here to send us a message.</RouterLink></p>
        </Content>
      </Block>
    </AboutPageLayout>
  );
});
